import React from 'react';
import { Moon } from 'lucide-react';
export function StoryHook() {
  return <section className="py-16 md:py-24 relative" data-id="element-165">
      <div className="container mx-auto px-4" data-id="element-166">
        <div className="max-w-3xl mx-auto glass-panel p-8 md:p-12 relative overflow-hidden" data-id="element-167">
          <div className="absolute top-0 right-0 -mt-4 -mr-4 text-navy-700 opacity-50" data-id="element-168">
            <Moon size={120} strokeWidth={1} data-id="element-169" />
          </div>

          <div className="relative z-10" data-id="element-170">
            <p className="text-lg md:text-xl leading-relaxed text-steel-200 mb-6 font-light" data-id="element-171">
              <span className="text-amber-400 font-serif text-2xl" data-id="element-172">E</span>stás
              acostada, el cuerpo está agotado, pero tu mente no se apaga.
              Repasas la lista de mañana, intentas recordar si respondiste ese
              correo crucial y, de repente, un pequeño pánico te sacude:
            </p>

            <blockquote className="border-l-2 border-amber-500 pl-6 my-8 py-2" data-id="element-173">
              <p className="text-2xl md:text-3xl font-serif text-white italic" data-id="element-174">
                "¿Se me está olvidando algo importante?"
              </p>
            </blockquote>

            <p className="text-lg leading-relaxed text-steel-300" data-id="element-175">
              Para la mujer hispana de más de 50 años que lidera una familia o
              un negocio, olvidar una palabra o un compromiso no es solo un
              descuido. Es una señal de alerta que genera una ansiedad
              silenciosa que no te deja descansar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}